const partners = {
	namespaced: true,
	state: {
		CustomersWithNoRecentSalesModalShow: false,
	},
	getters: {
		GE_CustomersWithoutInvoicesModalShow(state) {
			return state.CustomersWithNoRecentSalesModalShow;
		},
	},
	mutations: {
		MU_CustomersWithNoRecentSalesModalShow(state, show) {
			state.CustomersWithNoRecentSalesModalShow = show;
		},
	},
	actions: {
		AC_CustomersWithNoRecentSalesModalShow: ({ commit }, payload) => {
			commit('MU_CustomersWithNoRecentSalesModalShow', payload);
		},
	},
};

export default partners;
